import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Button from "@material-ui/core/Button";
import {deleteACard, loadCardsData, saveACard, updateACard, clearCardErrorMsg} from "../../redux/modules/card";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {bindActionCreators} from "redux";
import InputMask from 'react-input-mask'
//import {loadCamerasData} from "../../redux/modules/camera";
import {withStyles} from "@material-ui/core";
import DynamicTable from "./DynamicTable";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import CardCreditCard from "./CardCreditCard";
//import {loadLocationsData} from "../../redux/modules/location";
import GridList from '@material-ui/core/GridList';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Paper from '@material-ui/core/Paper';
import Draggable from 'react-draggable';
import CardFaxRecord from "./CardFaxRecord";
import CardExpandableRecord from "./CardExpandableRecord";
import * as MainConstants from "../../utils/MainConstants";
import {DEFAULT_VESPAAN_SERVER} from "../../utils/MainConstants";
import axios from "axios";
import jwt_decode from "jwt-decode";



const styles = theme => ({
    main: {
        width: 'auto',
        display: 'block', // Fix IE 11 issue.
        marginLeft: theme.spacing.unit * 3,
        marginRight: theme.spacing.unit * 3,
        [theme.breakpoints.up(400 + theme.spacing.unit * 3 * 2)]: {
            width: 400,
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    },
    paper: {
        marginTop: theme.spacing.unit * 8,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
    },
    avatar: {
        margin: theme.spacing.unit,
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing.unit,
    },
    submit: {
        marginTop: theme.spacing.unit * 3,
    },
    formControl: {
        margin: theme.spacing.unit,
        minWidth: 160,
    },
    formControl2: {
        margin: theme.spacing.unit,
        minWidth: 560,
        border: '4px solid',
        borderColor:'black',
        borderWidth:'4px'
    },
    formControl3: {
        margin: theme.spacing.unit,
        minWidth: 560,
        border: '4px solid',
        borderColor:'black',
        borderWidth:'4px'
    },
    selectEmpty: {
        marginTop: theme.spacing.unit * 2,
    },
    button: {
        marginTop: theme.spacing.unit * 3,
        marginLeft: theme.spacing.unit,
        backgroundColor:"#e2580d",
        color:"black",
        textTransform: "unset !important",
        width: '80%',
    },
    checkoutbutton: {
        marginTop: theme.spacing.unit * 3,
        //marginLeft: theme.spacing.unit,
        //backgroundColor:"#e2580d",
        color:"black",
        textTransform: "unset !important",
        width: '80%',
    },
    purchasebutton: {
        marginTop: theme.spacing.unit * 3,
        marginLeft: theme.spacing.unit,
        //backgroundColor:"#e2580d",
        color:"black",
        textTransform: "unset !important",
        //width: '80%',
    },
    gridList: {
        width:'100%',
        height:500,
    },
});

function PaperComponent(props) {
    return (
        <Draggable cancel={'[class*="MuiDialogContent-root"]'}>
            <Paper {...props} />
        </Draggable>
    );
}

const validateEmail = (email) => {
    // Basic email regex for demonstration
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
        //return 'Please enter a valid email address.';
        return false;
    }
    return true;
};

class CreditCard extends React.Component {


    state = {

        //selectedLocation:{},
        //selectedCard:{ "id":"", "country":"U.S.A", "state":"Massachusetts", "month":"-1", "year":"-1"},
        selectedCard:{ "id":"","number":"232323232342342342","name":"Farshid", "city":"newton", "address1":"156 Hartman Road", address2:" 3rd floor", zipcode:"032232", phone:"3232323234", "country":"U.S.A", "state":"Massachusetts", "month":"04", "year":"2025"},

        inputFieldShrinkState:true,
        numberShrink:false , //Jut sfor alter I can add a shrink flag for each filed.
        open:true,
        showCardSavedDialog: false,
        potPrice:'8.50',
        potCount:"",
        tax:0,
        shippingCost:0,
        grandTotal:0,
        shippingName:"Farin Azadeh",
        shippingAddress1:"400 Hanover Street",
        shippingAddress2:" 4th Floor",
        shippingCity:"Boston",
        shippingZipcode:"093222",
        shippingState:"Massachusetts",
        shippingPhone:"6179392232",
        shippingEmail:"fredi@yahoo.com",
        shippingCountry:"U.S.A",
        showCheckoutDialog: false,
        showDisclaimerDialog: false,



    };
    //const [open, setOpen] = React.useState(false);

    constructor(props) {
        super(props);
        this.editRecord = this.editRecord.bind(this);
        this.deleteRecord = this.deleteRecord.bind(this);
        this.clearFields = this.clearFields.bind(this);
        this.refresh = this.refresh.bind(this);
        this.handleGoToCheckout = this.handleGoToCheckout.bind(this);
        this.handleUpdate = this.handleUpdate.bind(this);
        this.handleFirstnameChange = this.handleFirstnameChange.bind(this);
        this.handleNameChange = this.handleNameChange.bind(this);
        this.handleAddress1Change = this.handleAddress1Change.bind(this);
        this.handleLastnameChange = this.handleLastnameChange.bind(this);

        this.handleAddress2Change = this.handleAddress2Change.bind(this);

        this.handleCityChange = this.handleCityChange.bind(this);
        this.handleStateChange = this.handleStateChange.bind(this);
        this.handleCountryChange = this.handleCountryChange.bind(this);
        this.handleZipcodeChange = this.handleZipcodeChange.bind(this);
        this.handleNumberChange = this.handleNumberChange.bind(this);
        this.handleLocationChange = this.handleLocationChange.bind(this);
        this.handleSecurityCodeChange = this.handleSecurityCodeChange.bind(this);
        this.getListOfCreditCards = this.getListOfCreditCards.bind(this);
        //this.handleClickOpen = this.handleClickOpen.bind(this);
        //this.handleClose = this.handleClose.bind(this);
        this.handlePhoneChange=this.handlePhoneChange.bind(this);
        this.handleMonthChange = this.handleMonthChange.bind(this);
        this.handleYearChange = this.handleYearChange.bind(this);

        this.handleClickShowSavedCard = this.handleClickShowSavedCard.bind(this);
        this.handleClickShowSavedCardClose = this.handleClickShowSavedCardClose.bind(this);
        this.handlePotCountChange = this.handlePotCountChange.bind(this);
        this.handlePriceAfterTaxChange = this.handlePriceAfterTaxChange.bind(this);
        this.calculateShippingCostPerPotCount = this.calculateShippingCostPerPotCount.bind(this);

        /* Shipping */
        this.handleShippingNameChange = this.handleShippingNameChange.bind(this);
        this.handleShippingAdd1Change = this.handleShippingAdd1Change.bind(this);
        this.handleShippingAdd2Change = this.handleShippingAdd2Change.bind(this);

        this.handleShippingCityChange = this.handleShippingCityChange.bind(this);
        this.handleShippingZipcodeChange = this.handleShippingZipcodeChange.bind(this);
        this.handleShippingStateChange = this.handleShippingStateChange.bind(this);
        this.handleShippingPhoneChange = this.handleShippingPhoneChange.bind(this);
        this.handleShippingEmailChange = this.handleShippingEmailChange.bind(this);
        this.handleShippingCountryChange = this.handleShippingCountryChange.bind(this);
        this.ifFieldIsEmpty = this.ifFieldIsEmpty.bind(this);
        this.handleClickShowCheckoutClose = this.handleClickShowCheckoutClose.bind(this);
        this.handleClickShowCheckout = this.handleClickShowCheckout.bind(this);
        this.getShippingCostFromServer = this.getShippingCostFromServer.bind(this);
        this.getArrayOfShippingCost = this.getArrayOfShippingCost.bind(this);
        this.getPurchaseFromServer = this.getPurchaseFromServer.bind(this);
        this.getArrayOfPurchase = this.getArrayOfPurchase.bind(this);
        this.getPotPriceFromServer=this.getPotPriceFromServer.bind(this);
        this.getArrayOfPotPrice=this.getArrayOfPotPrice.bind(this);
        this.handlePurchase=this.handlePurchase.bind(this);
        this.handleContinuePurchase=this.handleContinuePurchase.bind(this);

        this.handleClickShowDisclaimerClose = this.handleClickShowDisclaimerClose.bind(this);
        this.handleClickShowDisclaimer = this.handleClickShowDisclaimer.bind(this);













    }


    handleShippingCountryChange(event) {
        //event.preventDefault();
        this.setState(Object.assign( {shippingCountry:event.target.value}));
    }

    handleShippingCityChange(event) {
        //event.preventDefault();
        this.setState(Object.assign( {shippingCity:event.target.value}));
    }
    handleShippingZipcodeChange(event) {
        //event.preventDefault();
        this.setState(Object.assign( {shippingZipcode:event.target.value}));
    }
    handleShippingStateChange(event) {
        //event.preventDefault();
        this.setState(Object.assign( {shippingState:event.target.value}));
    }
    handleShippingPhoneChange(event) {
        //event.preventDefault();
        this.setState(Object.assign( {shippingPhone:event.target.value}));
    }

    handleShippingEmailChange(event) {
        //event.preventDefault();
        this.setState(Object.assign( {shippingEmail:event.target.value}));
    }

    handleShippingAdd2Change(event) {
        //event.preventDefault();
        this.setState(Object.assign( {shippingAddress2:event.target.value}));
    }

    handleShippingAdd1Change(event) {
        //event.preventDefault();
        this.setState(Object.assign( {shippingAddress1:event.target.value}));
    }
    handleShippingNameChange(event) {
        //event.preventDefault();
        this.setState(Object.assign( {shippingName:event.target.value}));
    }

    handleShippingNameChange(event) {
        //event.preventDefault();
        this.setState(Object.assign( {shippingName:event.target.value}));
    }

    calculateShippingCostPerPotCount(potCount){
        return ( this.state.shippingCost);
    }

    handlePriceAfterTaxChange(event) {
        //event.preventDefault();

        this.setState(Object.assign( {tax:event.target.value}));
    }

    ifFieldIsEmpty(argField, fieldName){
        let retBool= true;
        if(argField === null || argField=== undefined || argField.length === 0 || argField === "-1"){
            alert("Please enter the " + fieldName);
            retBool=false;
        }
        return retBool;
    }
    handlePotCountChange(event) {
        //event.preventDefault();

        /*if(this.ifFieldIsEmpty(this.state.shippingName, "Name for Shipping address") &&
        this.ifFieldIsEmpty(this.state.shippingAddress1, "Address for Shipping address") &&
        this.ifFieldIsEmpty(this.state.shippingCity, "City for Shipping address") &&
        this.ifFieldIsEmpty(this.state.shippingZipcode, "Zipcode for Shipping address") &&
        this.ifFieldIsEmpty(this.state.shippingState, "State for Shipping address") &&
        this.ifFieldIsEmpty(this.state.shippingPhone, "Phone for Shipping address") &&
        this.ifFieldIsEmpty(this.state.shippingCountry, "Country for Shipping address") ) {*/
        this.setState(Object.assign({potCount: event.target.value}));
        let calculatedTax = event.target.value * .0625;
        let calculateShippingCost = this.calculateShippingCostPerPotCount(event.target.value);

        this.setState(Object.assign({tax: calculatedTax}));
        this.setState(Object.assign({shippingCost: calculateShippingCost}));
        let granTotal = (this.state.potPrice * event.target.value) + calculatedTax + calculateShippingCost;
        this.setState(Object.assign({grandTotal: granTotal}));
        /*}*/
    }


    handleClickShowSavedCard() {
        this.setState({ showCardSavedDialog: true });
    };


    handleClickShowSavedCardClose() {
        let { clearCardErrorMsg } = this.props;
        this.setState({ showCardSavedDialog: false });
        clearCardErrorMsg();
    };


    handleClickShowCheckout() {
        this.setState({ showCheckoutDialog: true });
    };


    handleClickShowCheckoutClose() {
        let { clearCardErrorMsg } = this.props;
        this.setState({ showCheckoutDialog: false });
        //clearCardErrorMsg();
    };

    handleClickShowDisclaimer() {
        this.setState({ showDisclaimerDialog: true });
    };


    handleClickShowDisclaimerClose() {
        let { clearCardErrorMsg } = this.props;
        this.setState({ showDisclaimerDialog: false });
        //clearCardErrorMsg();
    };


    handleContinuePurchase () {
        //Farshid remove this later.
        this.handleClickShowDisclaimerClose();
        this.handleClickShowCheckoutClose();
        return;
        let { saveACard } = this.props;
        var tempStream = this.state.selectedCard ;

        /* Uncomment this later please FARSHID
        if(
            this.ifFieldIsEmpty(this.state.shippingName, "Name for Shipping address") &&
            this.ifFieldIsEmpty(this.state.shippingAddress1, "Address for Shipping address") &&
            this.ifFieldIsEmpty(this.state.shippingCity, "City for Shipping address") &&
            this.ifFieldIsEmpty(this.state.shippingZipcode, "Zipcode for Shipping address") &&
            this.ifFieldIsEmpty(this.state.shippingState, "State for Shipping address") &&
            this.ifFieldIsEmpty(this.state.shippingPhone, "Phone for Shipping address") &&
             this.ifFieldIsEmpty(this.state.shippingEmail, "Email for Shipping address") &&
            this.ifFieldIsEmpty(this.state.shippingCountry, "Country for Shipping address") &&
            this.ifFieldIsEmpty(this.state.selectedCard.number, "Number for Credit card") &&
            this.ifFieldIsEmpty(this.state.selectedCard.name, "Name for Credit card") &&
            this.ifFieldIsEmpty(this.state.selectedCard.address1, "Address for Credit card") &&
            this.ifFieldIsEmpty(this.state.selectedCard.city, "City for Credit card") &&
            this.ifFieldIsEmpty(this.state.selectedCard.zipcode, "Zipcode for Credit card") &&
            this.ifFieldIsEmpty(this.state.selectedCard.state, "State for Credit card") &&
            this.ifFieldIsEmpty(this.state.selectedCard.phone, "Phone for Credit card") &&
            this.ifFieldIsEmpty(this.state.selectedCard.country, "Country for Credit card") &&
            this.ifFieldIsEmpty(this.state.selectedCard.securityCode, "Security Code for Credit card") &&
            this.ifFieldIsEmpty(this.state.selectedCard.month, "Expiration Month  for Credit card") &&
            this.ifFieldIsEmpty(this.state.selectedCard.year, "Expiration Year  for Credit card")


        ) { */
        if(!validateEmail (this.state.shippingEmail)){
            alert("Please enter valid email, as part of shipping info");
        }
        let shippingInfo={}
        shippingInfo.name = this.state.shippingName;
        shippingInfo.address1 = this.state.shippingAddress1;
        shippingInfo.address2 = this.state.shippingAddress2;
        shippingInfo.city = this.state.shippingCity;
        shippingInfo.zipcode = this.state.shippingZipcode;
        shippingInfo.state = this.state.shippingState;
        shippingInfo.phone = this.state.shippingPhone;
        shippingInfo.email = this.state.shippingEmail;
        shippingInfo.country = this.state.shippingCountry;
        shippingInfo.potCount=this.state.potCount;

        let tempCost={};
        tempCost.potsCost=this.state.potCount*this.state.potPrice;
        tempCost.taxes=this.state.tax;
        tempCost.shippingAndHandling=this.state.shippingCost;
        tempCost.grandTotal=this.state.grandTotal;
        /*tempCost.potsCost= tempCost.potsCost.toFixed(2);
        tempCost.taxes= tempCost.taxes.toFixed(2);
        tempCost.shippingAndHandling= tempCost.shippingAndHandling.toFixed(2);
        tempCost.grandTotal= tempCost.grandTotal.toFixed(2);*/

        tempCost.potsCost= Math.round(tempCost.potsCost * 100)/100;
        tempCost.taxes= Math.round(tempCost.taxes * 100)/100;
        tempCost.shippingAndHandling= Math.round(tempCost.shippingAndHandling * 100)/100;
        tempCost.grandTotal=  Math.round(tempCost.grandTotal * 100)/100;




        this.getPurchaseFromServer(DEFAULT_VESPAAN_SERVER.url, shippingInfo, this.state.selectedCard, tempCost);
        this.handleClickShowCheckoutClose()
        //this.getPotPriceFromServer(DEFAULT_VESPAAN_SERVER.url);
        //this.handleClickShowCheckout();
        /*} */

    };
    handlePurchase () {
        this.handleClickShowDisclaimer();

    };

    handleGoToCheckout () {
        let { saveACard } = this.props;
        var tempStream = this.state.selectedCard ;
        console.log("Month is -->  ");
        console.log(this.state.selectedCard.month);
        /* Uncomment this later please FARSHID
        if(
            this.ifFieldIsEmpty(this.state.shippingName, "Name for Shipping address") &&
            this.ifFieldIsEmpty(this.state.shippingAddress1, "Address for Shipping address") &&
            this.ifFieldIsEmpty(this.state.shippingCity, "City for Shipping address") &&
            this.ifFieldIsEmpty(this.state.shippingZipcode, "Zipcode for Shipping address") &&
            this.ifFieldIsEmpty(this.state.shippingState, "State for Shipping address") &&
            this.ifFieldIsEmpty(this.state.shippingPhone, "Phone for Shipping address") &&
             this.ifFieldIsEmpty(this.state.shippingEmail, "Email for Shipping address") &&
            this.ifFieldIsEmpty(this.state.shippingCountry, "Country for Shipping address") &&
            this.ifFieldIsEmpty(this.state.selectedCard.number, "Number for Credit card") &&
            this.ifFieldIsEmpty(this.state.selectedCard.name, "Name for Credit card") &&
            this.ifFieldIsEmpty(this.state.selectedCard.address1, "Address for Credit card") &&
            this.ifFieldIsEmpty(this.state.selectedCard.city, "City for Credit card") &&
            this.ifFieldIsEmpty(this.state.selectedCard.zipcode, "Zipcode for Credit card") &&
            this.ifFieldIsEmpty(this.state.selectedCard.state, "State for Credit card") &&
            this.ifFieldIsEmpty(this.state.selectedCard.phone, "Phone for Credit card") &&
            this.ifFieldIsEmpty(this.state.selectedCard.country, "Country for Credit card") &&
            this.ifFieldIsEmpty(this.state.selectedCard.securityCode, "Security Code for Credit card") &&
            this.ifFieldIsEmpty(this.state.selectedCard.month, "Expiration Month  for Credit card") &&
            this.ifFieldIsEmpty(this.state.selectedCard.year, "Expiration Year  for Credit card")


        ) { */
        if(!validateEmail (this.state.shippingEmail)){
            alert("Please enter valid email, as part of shipping info");
        }
        let shippingInfo={}
        shippingInfo.name = this.state.shippingName;
        shippingInfo.address1 = this.state.shippingAddress1;
        shippingInfo.address2 = this.state.shippingAddress2;
        shippingInfo.city = this.state.shippingCity;
        shippingInfo.zipcode = this.state.shippingZipcode;
        shippingInfo.state = this.state.shippingState;
        shippingInfo.phone = this.state.shippingPhone;
        shippingInfo.email = this.state.shippingEmail;
        shippingInfo.country = this.state.shippingCountry;
        shippingInfo.potCount=this.state.potCount;

        let tempCost={};
        tempCost.potsCost=0.0;
        tempCost.taxes=0.0;
        tempCost.shippingAndHandling=0.0;
        tempCost.grandTotal=0.0;
        /*purchaseInfo.costs=argCost;
        purchaseInfo.costs.potsCost="0";
        purchaseInfo.costs.taxes="0";
        purchaseInfo.costs.shippingAndHandling="0";
        purchaseInfo.costs.grandTotal="0";*/


        this.getShippingCostFromServer(DEFAULT_VESPAAN_SERVER.url, shippingInfo, this.state.selectedCard, tempCost);
        //this.getPotPriceFromServer(DEFAULT_VESPAAN_SERVER.url);
        this.handleClickShowCheckout();
        /*} */

    };

    handleUpdate () {
        let { updateACard } = this.props;

        var tempStream = this.state.selectedCard ;
        //tempStream.locationId= this.state.selectedLocation.id;
        updateACard(DEFAULT_VESPAAN_SERVER.url,  tempStream);

    };

    handleZipcodeChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedCard,{zipcode:event.target.value}));
    }
    handleCountryChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedCard,{country:event.target.value}));
    }

    handleMonthChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedCard,{month:event.target.value}));
    }

    handleYearChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedCard,{year:event.target.value}));
    }

    handleStateChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedCard,{state:event.target.value}));
    }


    handleCityChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedCard,{city:event.target.value}));
    }

    handleAddress2Change(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedCard,{address2:event.target.value}));
    }

    handleAddress1Change(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedCard,{address1:event.target.value}));
    }

    handleFirstnameChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedCard,{firstName:event.target.value}));
    }


    handleLastnameChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedCard,{lastName:event.target.value}));
    }

    handleNameChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedCard,{name:event.target.value}));
    }

    handleSecurityCodeChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedCard,{securityCode:event.target.value}));
    }

    handleNumberChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedCard,{number:event.target.value}));
        //this.setState({numberShrink:true});
    }
    handlePhoneChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedCard,{phone:event.target.value}));
        //this.setState({numberShrink:true});
    }


    handleLocationChange(event) {
        //event.preventDefault();
        this.setState({selectedLocation: event.target.value});
        //this.setState({selectedVideoControllerName: event.target.value.displayName});
    }


    clearFields = (e) => {
        e.preventDefault();
        this.setState(state => ({
            inputFieldShrinkState:true
        }));


        var tempSelectedCard =   Object.assign({}, this.state.selectedCard);
        Object.keys(tempSelectedCard).map((key, index) => {
            tempSelectedCard[key] = "" ;
        });
        this.setState({selectedCard:tempSelectedCard})




    };

    getListOfCreditCards() {
        let tempArray = this.props.cardsArray;
        let returnArray=[];
        if (tempArray) {
            returnArray = tempArray.map((s) => {
                return(<CardCreditCard info={s}  onEdit={this.editRecord}  onDelete={this.deleteRecord}></CardCreditCard> );
            });
        }
        return(returnArray);
    }

    /*
    getListOfFaxes() {
        let tempArray = this.props.cardsArray;
        let returnArray=[];
        if (tempArray) {
            returnArray = tempArray.map((s) => {
                return(<CardExpandableRecord info={s}  onEdit={this.editRecord}  onDelete={this.deleteRecord}></CardExpandableRecord> );
            });
        }
        return(returnArray);
    }  */


    renderErrorFiled(data){


    }

    refresh(event) {
        let { loadCardsData } = this.props;
        loadCardsData(DEFAULT_VESPAAN_SERVER.url );
    }

    getPotPriceFromServer( argURL,  argShippingInfo, argCreditCard, argPotCount){
        var self=this;
        if((argURL != null) || (argURL.length !== 0)){
            axios.all(self.getArrayOfPotPrice(argURL)).then(function(responses){
                let fromServerPotPrice = responses[0].data;

                console.log("Pot Price is"+ fromServerPotPrice);
                self.setState({potPrice:fromServerPotPrice });

            }, function(err) {
                console.log("err");
                console.log(err);
                console.log("err.message");
                console.log(err.message);
                console.log("err.message.data");
                console.log(err.response.data);
                console.log("err.message.data.status");
                console.log(err.response.status);
                console.log(err.response.headers);
                console.log("Farshid some error occurred on getting shipping cost " + err.message +  " the URL is " + argURL );

            });
        }
    }



    getArrayOfPotPrice(argURL,  ){
        let baseUrl = argURL+"/potprice"
        var arrayOfGets = [];
        if(argURL != null) {
            arrayOfGets.push(axios.get(baseUrl));
        }
        return arrayOfGets;
    }

    getShippingCostFromServer( argURL,  argShippingInfo, argCreditCard, argCosts){
        var self=this;
        if((argURL != null) || (argURL.length !== 0)){
            axios.all(self.getArrayOfShippingCost(argURL, argShippingInfo, argCreditCard, argCosts)).then(function(responses){
                let fromServerShippingCost = responses[0].data;
                //FARSHID Look into the return value from teh server.
                console.log("shipping cost is "+ fromServerShippingCost);
                self.setState({shippingCost:fromServerShippingCost});
                let grandTotal = (self.state.potPrice * self.state.potCount) + self.state.tax + fromServerShippingCost;
                self.setState(Object.assign({grandTotal: grandTotal}));

            }, function(err) {
                console.log("err");
                console.log(err);
                console.log("err.message");
                console.log(err.message);
                console.log("err.message.data");
                console.log(err.response.data);
                console.log("err.message.data.status");
                console.log(err.response.status);
                console.log(err.response.headers);
                console.log("Farshid some error occurred on getting shipping cost " + err.message +  " the URL is " + argURL );

            });
        }
    }



    getArrayOfShippingCost(argURL, argShippingInfo, argCreditCard, argCost){
        let baseUrl = argURL+"/shippingcost"
        var arrayOfGets = [];
        if(argURL != null) {
            let purchaseInfo={};
            purchaseInfo.shipping=argShippingInfo;
            purchaseInfo.card=argCreditCard;
            purchaseInfo.costs=argCost;
            console.log("printing purchase-info");
            console.log(purchaseInfo);
            arrayOfGets.push(axios.post(baseUrl, purchaseInfo ));
        }
        return arrayOfGets;
    }






    getPurchaseFromServer( argURL,  argShippingInfo, argCreditCard, argCosts){
        var self=this;
        if((argURL != null) || (argURL.length !== 0)){
            axios.all(self.getArrayOfPurchase(argURL, argShippingInfo, argCreditCard, argCosts)).then(function(responses){
                let fromServerShippingCost = responses[0].data;
                //FARSHID Look into the return value from teh server.
                console.log("shipping cost is "+ fromServerShippingCost);
                self.setState({shippingCost:fromServerShippingCost});
                let grandTotal = (self.state.potPrice * self.state.potCount) + self.state.tax + fromServerShippingCost;
                self.setState(Object.assign({grandTotal: grandTotal}));

            }, function(err) {
                console.log("err");
                console.log(err);
                console.log("err.message");
                console.log(err.message);
                console.log("err.message.data");
                console.log(err.response.data);
                console.log("err.message.data.status");
                console.log(err.response.status);
                console.log(err.response.headers);
                console.log("Farshid some error occurred on getting shipping cost " + err.message +  " the URL is " + argURL );

            });
        }
    }



    getArrayOfPurchase(argURL, argShippingInfo, argCreditCard, argCost){
        let baseUrl = argURL+"/purchase"
        var arrayOfGets = [];
        if(argURL != null) {
            let purchaseInfo={};
            purchaseInfo.shipping=argShippingInfo;
            purchaseInfo.card=argCreditCard;
            purchaseInfo.costs=argCost;
            console.log("printing purchase-info");
            console.log(purchaseInfo);
            arrayOfGets.push(axios.post(baseUrl, purchaseInfo ));
        }
        return arrayOfGets;
    }



    render() {
        const {classes} = this.props;
        let creditCardList = this.getListOfCreditCards();

        let usStates = MainConstants.getUSStates();
        let canStates = MainConstants.getCanadaStates();
        let availableCountries = MainConstants.getCountries();
        let months = MainConstants.getMonths();
        let years = MainConstants.getYears();

        let inputBoxColor ='white';
        return (
            <React.Fragment  >
                <div    style = { {    width:'100%' , border: '4px solid',  borderColor:'black', borderWidth:'4px'}} >
                    <Typography variant="h6" gutterBottom style = { { textAlign: 'center', alignSelf: 'center'  , backgroundColor:'#0cad9d', fontSize:26, marginLeft:0}} >
                        Order Information
                    </Typography>
                    <Grid container spacing={24}  >
                        <Grid item xs={12} sm={12}>
                            <Grid container >


                                <Grid item xs={4} sm={4} >
                                </Grid>
                                <Grid   xs={4} sm={4}  >
                                    <Typography  style = { {textDecoration: 'underline', textAlign: 'center', alignSelf: 'center'  , backgroundColor:'white', fontSize:26, marginLeft:3, marginTop:10, marginBottom:10 }} >   Shipping Address  </Typography>
                                </Grid>
                                <Grid item xs={4} sm={4} >
                                </Grid>

                                <Grid item xs={12} sm={12}   md={5} lg={5}   xl={5} style = { { textAlign: 'left', alignSelf: 'left'  ,   fontSize:26, marginLeft:10, }} >
                                    <TextField  required id="shippingName" name="shippingName" label="Full Name"  fullWidth style = { { textAlign: 'left', alignSelf: 'left'  , backgroundColor:inputBoxColor, fontSize:26, marginLeft:0 }} InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.shippingName} onChange={this.handleShippingNameChange}  />
                                </Grid>
                                <Grid item xs={0} sm={0}   md={7} lg={7}   xl={7} >
                                </Grid>
                                <Grid item xs={12} md={12} lg={12}   xl={12} style = { { textAlign: 'left', alignSelf: 'left'  ,   fontSize:26, marginLeft:10,marginTop:10,  }}>
                                    <TextField id="shipAddress1" name="shipAddress1" label="Address line 1" fullWidth style = { { textAlign: 'center', alignSelf: 'center'  , backgroundColor:inputBoxColor, fontSize:26, marginLeft:0, width:'70%'}} InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.shippingAddress1} onChange={this.handleShippingAdd1Change} />
                                </Grid>
                                <Grid item xs={12} md={12} lg={12}   xl={12} style = { { textAlign: 'left', alignSelf: 'left'  ,   fontSize:26, marginLeft:10,marginTop:10,  }}>
                                    <TextField id="shipAddress2" name="shipAddress2" label="Address line 2" fullWidth style = { { textAlign: 'center', alignSelf: 'center'  , backgroundColor:inputBoxColor, fontSize:26, marginLeft:0, width:'70%'}} InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.shippingAddress2} onChange={this.handleShippingAdd2Change} />
                                </Grid>
                                <Grid container >
                                    <Grid item xs={12} md={12} lg={5}   xl={5}   >
                                        <TextField required id="city" name="city" label="City" fullWidth style = { { textAlign: 'center', alignSelf: 'center'  ,marginTop:10,  backgroundColor:inputBoxColor, fontSize:26, marginLeft:10,width:'70%'}} InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.shippingCity} onChange={this.handleShippingCityChange}/>
                                    </Grid>
                                    <Grid item xs={2} sm={2} >
                                    </Grid>
                                    <Grid item xs={12} md={12} lg={5}   xl={5}  style = { { textAlign: 'left', alignSelf: 'left'  ,   fontSize:26, marginLeft:0 }}>

                                        <TextField id="Country" name="Country" label="Country" fullWidth style = { { textAlign: 'center', alignSelf: 'center'  , backgroundColor:inputBoxColor, fontSize:26, marginLeft:10, width:'70%'}} InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.shippingCountry} onChange={this.handleShippingCountryChange}
                                                   inputProps={{readOnly: true,}}/>

                                        {/*<FormControl className={classes.formControl} style = { { textAlign: 'left', alignSelf: 'left'  , backgroundColor:inputBoxColor, fontSize:26, marginLeft:10}}>
                                        <InputLabel htmlFor="age-helper">Country</InputLabel>
                                        <Select value={this.state.shippingCountry}
                                                onChange={ this.handleShippingCountryChange}
                                                inputProps={{
                                                    name: 'country',
                                                    id: 'country-helper',
                                                }}
                                        >
                                            {availableCountries}

                                        </Select>

                                    </FormControl>*/}
                                    </Grid>
                                    <Grid item xs={12} md={12} lg={5}   xl={5} >
                                        <TextField  required  id="zip"  name="zip"  label="Zip / Postal code"  fullWidth style = { { textAlign: 'center', alignSelf: 'center'  , backgroundColor:inputBoxColor, fontSize:26, marginLeft:10, marginTop:10,width:'70%' }}  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.shippingZipcode} onChange={this.handleShippingZipcodeChange}  />
                                    </Grid>

                                    <Grid item xs={2} sm={2} >
                                    </Grid>

                                    <Grid item xs={12} md={12} lg={5}   xl={5}   style = { { textAlign: 'left', alignSelf: 'left'  ,   fontSize:26, marginLeft:0 }}>
                                        {/*<TextField id="state" name="state" label="State/Province/Region" fullWidth InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedCard.state} onChange={this.handleStateChange}/>
                                                               */}
                                        <FormControl className={classes.formControl} style = { { textAlign: 'left', alignSelf: 'left'  , backgroundColor:inputBoxColor, fontSize:26, marginLeft:10}}>
                                            <InputLabel htmlFor="age-helper">State</InputLabel>
                                            <Select value={this.state.shippingState}
                                                    onChange={ this.handleShippingStateChange}
                                                    inputProps={{
                                                        name: 'state',
                                                        id: 'state-helper',
                                                    }}
                                            >

                                                {(this.state.shippingCountry == "U.S.A") &&  (usStates) }
                                                { (this.state.shippingCountry != "U.S.A") && (canStates)}


                                            </Select>
                                            {/* <FormHelperText>Select a State </FormHelperText> */}
                                        </FormControl>

                                    </Grid>


                                    <Grid item xs={12} md={12} lg={5}   xl={5}>
                                        <InputMask mask="(999) 999-9999"  value={this.state.shippingPhone} onChange={this.handleShippingPhoneChange} >
                                            {()=> <TextField  required id="phone"  name="phone"  label="Phone"  fullWidth style = { { textAlign: 'center', alignSelf: 'center'  , backgroundColor:inputBoxColor, fontSize:26, marginLeft:10, marginTop:10,width:'70%' }}  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  />  }
                                        </InputMask>
                                    </Grid>
                                    <Grid item xs={2} sm={2} >
                                    </Grid>
                                    <Grid item xs={12} md={12} lg={5}   xl={5}>
                                        <TextField  required  type="email" id="email"  name="email"  label="Email"  fullWidth style = { { textAlign: 'center', alignSelf: 'center'  , backgroundColor:inputBoxColor, fontSize:26, marginLeft:10, marginTop:10,width:'70%' }}  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.shippingEmail} onChange={this.handleShippingEmailChange}  />
                                        {/*
                                    <InputMask mask="(999) 999-9999"  value={this.state.shippingEmail} onChange={this.handleShippingEmailChange} >
                                        {()=> <TextField  required id="email"  name="email"  label="Email"  fullWidth style = { { textAlign: 'center', alignSelf: 'center'  , backgroundColor:inputBoxColor, fontSize:26, marginLeft:10, marginTop:10, }}  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  />  }
                                    </InputMask>*/}
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    <br/>
                    <br/>
                    {/*<Grid item xs={12} sm={12}   style={{backgroundColor:'red' }}>
                    <div  style={{display: 'flex',
                        flexDirection: 'row' }}>
                        <TextField required  variant="outlined" id="number" name="potCount"  label="Number of Pots"  fullWidth style = { { textAlign: 'center', alignSelf: 'center'  , backgroundColor:inputBoxColor, fontSize:26, marginLeft:0,  width:'10%'}}  InputLabelProps={{ shrink: this.state.inputFieldShrinkState || this.state.numberShrink  }}  value={this.state.potCount} onChange={this.handlePotCountChange}/>

                        <Typography  style={{fontSize:20 , textAlign: 'center', alignSelf: 'left'  , width:'12%', marginTop:10, marginLeft:5 }}>   @ {this.state.potPrice}  each </Typography>
                        <Typography  style={{fontSize:20 , textAlign: 'center', alignSelf: 'center'  , width:'17%'}}> =  {this.state.potPrice * this.state.potCount}  </Typography>

                         </div>
                </Grid>*/}
                    {/*<Grid item xs={12} sm={12} >
                    <div  style={{display: 'flex',
                        flexDirection: 'row', marginTop:10}}>


                        <Typography  style={{fontSize:20 , textAlign: 'left', alignSelf: 'left'  , width:'30%'}}>Tax  %5</Typography>

                        <Typography  style={{fontSize:20 , textAlign: 'left', alignSelf: 'left'  , width:'40%'}}>   = {( this.state.tax).toFixed(2)}  </Typography>
                    </div>
                </Grid>*/}
                    <Grid container spacing={24}  >
                        <Grid item xs={12} sm={12}  md={12} lg={12}   xl={12} >
                        </Grid>
                        <Grid item xs={12} sm={12}  md={6} lg={6}   xl={6}  style={{   border: '3px solid', borderSize:5, borderColor:'black',  marginLeft:3, marginRight:3 }}>
                            <div  style={{display: 'flex',
                                flexDirection: 'row'  }}>
                                <TextField required  variant="outlined"  type="number" id="number" name="potCount"  label="Pots Count"  fullWidth  style = { { textAlign: 'center', alignSelf: 'center'  , backgroundColor:inputBoxColor, fontSize:32, marginLeft:10, marginTop:5, marginBottom:4, width:'30%', borderColor:'red', borderWidth:'5' }} inputProps={{ min: "0" , max:"10", style: {fontSize: 22}}}
                                           InputLabelProps={{  style: { fontSize:20 }, shrink: this.state.inputFieldShrinkState || this.state.numberShrink  }}  value={this.state.potCount} onChange={this.handlePotCountChange}/>

                                <Typography  style={{fontSize:20 , textAlign: 'center', alignSelf: 'left'   , marginTop:17, marginLeft:5 , width:'34%'}}> @ ${this.state.potPrice} each </Typography>
                                <Typography  style={{fontSize:20 , textAlign: 'left', alignSelf: 'center' , width:'40%' }}>= ${this.state.potPrice * this.state.potCount}  </Typography>

                            </div>
                            {/*}
                    <div  style={{display: 'flex',
                        flexDirection: 'row', marginTop:10}}>
                        <Typography  style={{fontSize:20 , textAlign: 'left', alignSelf: 'left'  , width:'55%'}}>Tax  %5</Typography>

                        <Typography  style={{fontSize:20 , textAlign: 'left', alignSelf: 'left'  , width:'40%'}}>   = {( this.state.tax).toFixed(2)}  </Typography>


                        </div>
                    <div  style={{display: 'flex',
                        flexDirection: 'row',}}>

                        <Typography  style={{fontSize:20 , textAlign: 'left', alignSelf: 'left'  , width:'55%'}}>Shipping & Handling </Typography>

                        <Typography  style={{fontSize:20 , textAlign: 'left', alignSelf: 'left'  , width:'40%'}}> =  {(this.state.shippingCost).toFixed(2)}  </Typography>


                         </div>
                    <div  style={{display: 'flex',
                        flexDirection: 'row',}}>

                        <Typography  style={{fontSize:20 , textAlign: 'left', alignSelf: 'left'  , width:'55%'}}>Grand Total </Typography>

                        <Typography  style={{fontSize:20 , textAlign: 'left', alignSelf: 'left'  , width:'40%'}}>  =  {( this.state.grandTotal).toFixed(2)}  </Typography>


                         </div>
                    */}
                        </Grid>
                        <Grid item xs={12} sm={12}  md={12} lg={12}   xl={12} >
                        </Grid>
                    </Grid>
                    {/*<Grid item xs={12} sm={12} >
                    <div  style={{display: 'flex',
                        flexDirection: 'row',}}>

                        <Typography  style={{fontSize:20 , textAlign: 'left', alignSelf: 'left'  , width:'30%'}}>Grand Total </Typography>

                        <Typography  style={{fontSize:20 , textAlign: 'left', alignSelf: 'left'  , width:'40%'}}>  =  {( this.state.grandTotal).toFixed(2)}  </Typography>


                    </div>
                </Grid>*/}
                    <Grid container spacing={24}>
                        <Grid item xs={4} sm={4} >
                        </Grid>


                        <Grid item xs={4} sm={4} >

                            <Typography variant="h6" gutterBottom  style = { {textDecoration: 'underline', textAlign: 'center', alignSelf: 'center'  , backgroundColor:'white', fontSize:26, marginLeft:0, marginTop:20}} >
                                Credit Card Information
                            </Typography>
                        </Grid>
                        <Grid item xs={4} sm={4} >
                        </Grid>
                    </Grid>
                    <Grid container spacing={24}>

                        <Grid item xs={12} sm={12}>
                            <Grid container >
                                <Grid item xs={12} sm={12}>
                                    <Grid container >

                                        <Grid item xs={12} sm={12}  md={5} lg={5}   xl={5} >
                                            <TextField required  type="number"  id="number" name="number"  label="Card Number"  fullWidth style = { { textAlign: 'center', alignSelf: 'center'  , backgroundColor:inputBoxColor, fontSize:26, marginLeft:10, width:'70%'}}  InputLabelProps={{ shrink: this.state.inputFieldShrinkState || this.state.numberShrink  }}  value={this.state.selectedCard.number} onChange={this.handleNumberChange}/>
                                        </Grid>
                                        <Grid item xs={0} sm={0}   md={7} lg={7}   xl={7} >
                                        </Grid>
                                        <Grid item xs={5} sm={5} >
                                            <TextField required id="name" name="name"  label="Name on the card"  fullWidth style = { { textAlign: 'center', alignSelf: 'center'  , backgroundColor:inputBoxColor, fontSize:26, marginLeft:10,marginTop:10,}} InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedCard.name} onChange={this.handleNameChange}/>
                                        </Grid>
                                        <Grid item xs={0} sm={0}   md={7} lg={7}   xl={7} >
                                        </Grid>
                                    </Grid>

                                    <Grid item xs={12} md={12} lg={12}   xl={12} style = { { textAlign: 'left', alignSelf: 'left'  ,   fontSize:26, marginLeft:10,marginTop:10,  }}>
                                        <TextField  required id="address1" name="address1" label="Address line 1"  fullWidth style = { { textAlign: 'left', alignSelf: 'left'  , backgroundColor:inputBoxColor, fontSize:26, marginLeft:0, marginTop:10,width:'70%'}} InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedCard.address1} onChange={this.handleAddress1Change}  />
                                    </Grid>
                                    <Grid item xs={12} md={12} lg={12}   xl={12} style = { { textAlign: 'left', alignSelf: 'left'  ,   fontSize:26, marginLeft:10,marginTop:10,  }}>
                                        <TextField id="address2" name="address2" label="Address line 2" fullWidth style = { { textAlign: 'center', alignSelf: 'center'  , backgroundColor:inputBoxColor, fontSize:26, marginLeft:0, marginTop:10,width:'70%'}} InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedCard.address2} onChange={this.handleAddress2Change} />
                                    </Grid>
                                    <Grid container >
                                        <Grid item xs={12} md={12} lg={5}   xl={5} >
                                            <TextField required id="city" name="city" label="City" fullWidth style = { { textAlign: 'center', alignSelf: 'center'  , backgroundColor:inputBoxColor, fontSize:26, marginLeft:10, marginTop:10, width:'70%'}} InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedCard.city} onChange={this.handleCityChange}/>
                                        </Grid>
                                        <Grid item xs={2} sm={2} >
                                        </Grid>
                                        <Grid item xs={12} md={12} lg={5}   xl={5} style = { { textAlign: 'left', alignSelf: 'left'  ,   fontSize:26, marginLeft:0 }}>

                                            <TextField id="Country" name="Country" label="Country" fullWidth style = { { textAlign: 'center', alignSelf: 'center'  , backgroundColor:inputBoxColor, fontSize:26, marginLeft:10, width:'70%'}} InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedCard.country} onChange={this.handleCountryChange}
                                                       inputProps={{readOnly: true,}}/>

                                            {/*<FormControl className={classes.formControl} style = { { textAlign: 'left', alignSelf: 'left'  , backgroundColor:inputBoxColor, fontSize:26, marginLeft:10}}>
                                            <InputLabel htmlFor="age-helper">Country</InputLabel>
                                            <Select value={this.state.selectedCard.country}
                                                    onChange={ this.handleCountryChange}
                                                    inputProps={{
                                                        name: 'country',
                                                        id: 'country-helper',
                                                    }}
                                            >

                                                {availableCountries}

                                            </Select>

                                        </FormControl>*/}




                                        </Grid>
                                        <Grid item xs={5} sm={5} md={5} lg={5}   xl={5}>
                                            <TextField  required  id="zip"  name="zip"  label="Zip / Postal code"  fullWidth style = { { textAlign: 'center', alignSelf: 'center'  , backgroundColor:inputBoxColor, fontSize:26, marginLeft:10}}  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedCard.zipcode} onChange={this.handleZipcodeChange}  />
                                        </Grid>
                                        <Grid item xs={2} sm={2} >
                                        </Grid>
                                        <Grid itemxs={12} md={12} lg={5}   xl={5} style = { { textAlign: 'left', alignSelf: 'left'  ,   fontSize:26, marginLeft:0 }}>
                                            {/*<TextField id="state" name="state" label="State/Province/Region" fullWidth InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedCard.state} onChange={this.handleStateChange}/>
                                                               */}
                                            <FormControl className={classes.formControl} style = { { textAlign: 'left', alignSelf: 'left'  , backgroundColor:inputBoxColor, fontSize:26, marginLeft:10}}>
                                                <InputLabel htmlFor="age-helper">State</InputLabel>
                                                <Select value={this.state.selectedCard.state}
                                                        onChange={ this.handleStateChange}
                                                        inputProps={{
                                                            name: 'state',
                                                            id: 'state-helper',
                                                        }}
                                                >

                                                    {(this.state.selectedCard.country == "U.S.A") &&  (usStates) }
                                                    { (this.state.selectedCard.country != "U.S.A") && (canStates)}


                                                </Select>
                                                {/* <FormHelperText>Select a State </FormHelperText> */}
                                            </FormControl>

                                        </Grid>


                                        <Grid item xs={12} sm={12}  md={5} lg={5}   xl={5} style = { { textAlign: 'left', alignSelf: 'left'  , backgroundColor:inputBoxColor, fontSize:26, marginLeft:10, marginTop:10}} >
                                            <InputMask mask="(999) 999-9999"  value={this.state.selectedCard.phone} onChange={this.handlePhoneChange} >
                                                {()=> <TextField  required id="phone"  name="phone"  label="Phone"  fullWidth style = { { textAlign: 'center', alignSelf: 'center'  , backgroundColor:inputBoxColor, fontSize:26, marginLeft:0,width:'70%'}}  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  />  }
                                            </InputMask>
                                        </Grid>
                                        <Grid item xs={0} sm={0}  md={7} lg={7}   xl={7} >
                                        </Grid>
                                        <Grid item xs={12} sm={12}  md={5} lg={5}   xl={5} style = { { textAlign: 'left', alignSelf: 'left'  , backgroundColor:inputBoxColor, fontSize:26, marginLeft:10, marginTop:10}} >
                                            <TextField  required id="securityCode" name="securityCode" label="Security Code"  fullWidth  style = { { textAlign: 'center', alignSelf: 'center'  , backgroundColor:inputBoxColor, fontSize:26, marginLeft:0, width:'70%'}} InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedCard.securityCode} onChange={this.handleSecurityCodeChange}  />
                                        </Grid>
                                        <Grid item xs={0} sm={0}  md={6} lg={6}   xl={6} >
                                        </Grid>
                                        <Grid item xs={12} sm={12}  md={2} lg={2}   xl={2}>
                                            <FormControl className={classes.formControl} style = { { textAlign: 'left', alignSelf: 'left'  , backgroundColor:inputBoxColor, fontSize:26, marginLeft:10}}>
                                                <InputLabel htmlFor="age-helper">Expiration Month</InputLabel>
                                                <Select value={this.state.selectedCard.month}
                                                        onChange={ this.handleMonthChange}
                                                        inputProps={{
                                                            name: 'month',
                                                            id: 'month-helper',
                                                        }}>
                                                    {months}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={0} sm={0}  md={1} lg={1}   xl={1} >
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
                                            <FormControl className={classes.formControl} style = { { textAlign: 'left', alignSelf: 'left'  , backgroundColor:inputBoxColor, fontSize:26,    }}>
                                                <InputLabel htmlFor="age-helper">Expiration Year</InputLabel>
                                                <Select value={this.state.selectedCard.year}
                                                        onChange={ this.handleYearChange}
                                                        inputProps={{
                                                            name: 'year',
                                                            id: 'year-helper',
                                                        }}>
                                                    {years}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={0} sm={0} md={7} lg={7} xl={7}>
                                        </Grid>


                                        <Grid item xs={12} sm={12}  md={4} lg={4}   xl={4} >
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>

                                            <Button variant="contained" color="primary" onClick={this.handleGoToCheckout} style = { { border: '3px solid', borderSize:5, borderColor:'black', textAlign: 'left', alignSelf: 'left'  ,color:'white', backgroundColor:'#1a736a', fontSize:20, marginLeft:20}} className={classes.checkoutbutton}> Checkout
                                            </Button>
                                        </Grid>
                                        <Grid item xs={12} sm={12}  md={4} lg={4}   xl={4} >
                                        </Grid>
                                    </Grid>
                                    <br/>
                                    <br/>
                                </Grid>
                                <Grid item xs={1} sm={1} >
                                </Grid>
                                <Grid item xs={6} sm={6}>

                                </Grid>

                            </Grid>
                            <Grid container >

                            </Grid>
                        </Grid>
                        {/* This is for submit event error/success display */}
                        <Dialog
                            open={this.state.showCardSavedDialog}
                            onClose={this.handleClickShowSavedCardClose}
                            scroll={'paper'}
                            classes={{
                                paper: classes.formControl2,
                            }}
                            aria-labelledby="scroll-dialog-title"
                            aria-describedby="scroll-dialog-description"
                            maxWidth="xl"
                        >
                            <DialogTitle id="scroll-dialog-title">Credit Card Information</DialogTitle>
                            <DialogContent id="farshids" dividers="paper"  style={{  justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>

                                {(this.props.errorCMsg.status == 200) && (<div>
                                    The Operation was SUCCESSFUL!  Please refresh the list by pressing the refresh button -  {this.props.errorCMsg.status}  {this.props.errorCMsg.statusText}
                                </div>)}
                                {(this.props.errorCMsg.status != 200) && (this.props.errorCMsg.status != null) && (<div>
                                    The Operation FAILED, please try again! -  {this.props.errorCMsg.status} - {this.props.errorCMsg.statusText}
                                </div>)}

                            </DialogContent>
                            <DialogActions>
                                {/*
																										<Tooltip title="Selected entities will receive police notice">
																											<Button  color="primary" onClick={this.sendEmail}>Send EMAIL</Button>
																										</Tooltip>
																										*/}
                                <Button onClick={this.handleClickShowSavedCardClose} color="secondary">Close</Button>
                            </DialogActions>
                        </Dialog>
                        {/* Checkout log out box */}
                        <Dialog
                            open={this.state.showCheckoutDialog}
                            onClose={this.handleClickShowCheckoutClose}
                            scroll={'paper'}
                            classes={{
                                paper: classes.formControl2,
                            }}
                            style = { {    width:'100%' , border: '4px solid',  borderColor:'black', borderWidth:'4px'}}
                            aria-labelledby="scroll-dialog-title"
                            aria-describedby="scroll-dialog-description"
                            maxWidth="md"
                        >
                            <DialogTitle id="scroll-dialog-title" style={{marginLeft:20, textAlign: 'center', alignSelf: 'left'}}>Checkout Information</DialogTitle>
                            <DialogContent id="checkout" dividers="paper">
                                <Grid container spacing={24}  >
                                    <Grid item xs={1} sm={1}  md={12} lg={12}   xl={12}>

                                    </Grid>
                                    <Grid item xs={10} sm={10}  md={12} lg={12}   xl={12}>


                                        <Grid item xs={12} sm={12}  md={12} lg={12}   xl={12}  style={{ backgroundColor:'#dff5f4'  }}>
                                            <div  style={{display: 'flex',
                                                flexDirection: 'row' }}>
                                                <Typography  style={{fontSize:20 , textAlign: 'center', alignSelf: 'left'   , marginTop:10, marginLeft:5 ,marginRight:15 , backgroundColor:'#0cad9d', width:'100%'}}> Shipping Information </Typography>

                                            </div>

                                            <div  style={{display: 'flex',
                                                flexDirection: 'column' }}>
                                                <Typography  style={{fontSize:20 , textAlign: 'left', alignSelf: 'left'   , marginTop:10, marginLeft:5 , width:'100%'}}> {this.state.shippingName} </Typography>
                                                <Typography  style={{fontSize:20 , textAlign: 'left', alignSelf: 'left'   , marginTop:5, marginLeft:5 , width:'100%'}}> {this.state.shippingAddress1} </Typography>
                                                <Typography  style={{fontSize:20 , textAlign: 'left', alignSelf: 'left'   , marginTop:5, marginLeft:5 , width:'100%'}}> {this.state.shippingAddress2} </Typography>
                                                <div  style={{display: 'flex',
                                                    flexDirection: 'row' }}>
                                                    <Typography  style={{fontSize:20 , textAlign: 'left', alignSelf: 'left'   , marginTop:5, marginLeft:5  }}> {this.state.shippingCity} </Typography>
                                                    <Typography  style={{fontSize:20 , textAlign: 'left', alignSelf: 'left'   , marginTop:5, marginLeft:1  }}>,  {this.state.shippingState} </Typography>
                                                    <Typography  style={{fontSize:20 , textAlign: 'left', alignSelf: 'left'   , marginTop:5, marginLeft:5  }}> {this.state.shippingZipcode} </Typography>

                                                    <Typography  style={{fontSize:20 , textAlign: 'left', alignSelf: 'left'   , marginTop:5, marginLeft:5  }}> {this.state.shippingCountry} </Typography>
                                                </div>
                                            </div>
                                            <div  style={{display: 'flex',
                                                flexDirection: 'row', marginTop:10}}>
                                                <Typography  style={{fontSize:20 , textAlign: 'center', alignSelf: 'left'   , marginTop:10, marginLeft:5 , marginRight:15 ,width:'100%',backgroundColor:'#0cad9d',}}> Credit Card Information </Typography>
                                            </div>
                                            <div  style={{display: 'flex',
                                                flexDirection: 'column' }}>
                                                <Typography  style={{fontSize:20 , textAlign: 'left', alignSelf: 'left'   , marginTop:10, marginLeft:5 , width:'100%'}}> {this.state.selectedCard.name} </Typography>
                                                <Typography  style={{fontSize:20 , textAlign: 'left', alignSelf: 'left'   , marginTop:5, marginLeft:5 , width:'100%'}}> {this.state.selectedCard.address1} </Typography>
                                                <Typography  style={{fontSize:20 , textAlign: 'left', alignSelf: 'left'   , marginTop:5, marginLeft:5 , width:'100%'}}> {this.state.selectedCard.address2} </Typography>

                                                <div  style={{display: 'flex',
                                                    flexDirection: 'row' }}>
                                                    <Typography  style={{fontSize:20 , textAlign: 'left', alignSelf: 'left'   , marginTop:5, marginLeft:5  }}> {this.state.selectedCard.city} </Typography>
                                                    <Typography  style={{fontSize:20 , textAlign: 'left', alignSelf: 'left'   , marginTop:5, marginLeft:1  }}>,  {this.state.selectedCard.state} </Typography>
                                                    <Typography  style={{fontSize:20 , textAlign: 'left', alignSelf: 'left'   , marginTop:5, marginLeft:5  }}> {this.state.selectedCard.zipcode} </Typography>

                                                    <Typography  style={{fontSize:20 , textAlign: 'left', alignSelf: 'left'   , marginTop:5, marginLeft:5  }}> {this.state.selectedCard.country} </Typography>
                                                </div>
                                                <Typography  style={{fontSize:20 , textAlign: 'left', alignSelf: 'left'   , marginTop:5, marginLeft:5  }}> {this.state.selectedCard.number} </Typography>

                                                <Typography  style={{fontSize:20 , textAlign: 'left', alignSelf: 'left'   , marginTop:5, marginLeft:5  }}> Expiration Date: {this.state.selectedCard.month}/{this.state.selectedCard.year} </Typography>



                                            </div>


                                        </Grid>

                                        <Grid item xs={12} sm={12}  md={12} lg={12}   xl={12}  style={{ backgroundColor:'#dff5f4'  }}>
                                            <div  style={{display: 'flex',
                                                flexDirection: 'row' }}>
                                                <Typography  style={{fontSize:20 , textAlign: 'center', alignSelf: 'left'   , marginTop:10, marginLeft:5 ,marginRight:15 , backgroundColor:'#0cad9d', width:'100%'}}> Fees </Typography>

                                            </div>
                                            <div  style={{display: 'flex',
                                                flexDirection: 'row' }}>
                                                <Typography  style={{fontSize:20 , textAlign: 'left', alignSelf: 'left'   , marginTop:10, marginLeft:5 , width:'27%'}}> {this.state.potCount} </Typography>
                                                <Typography  style={{fontSize:20 , textAlign: 'left', alignSelf: 'left'   , marginTop:10, marginLeft:5 , width:'26%'}}> @ {this.state.potPrice} each </Typography>
                                                <Typography  style={{fontSize:20 , textAlign: 'left', alignSelf: 'center' , width:'40%'  }}>= {this.state.potPrice * this.state.potCount}  </Typography>

                                            </div>
                                            <div  style={{display: 'flex',
                                                flexDirection: 'row', marginTop:10}}>
                                                <Typography  style={{fontSize:20 , textAlign: 'left', alignSelf: 'left'  , width:'55%'}}>Tax  %6.25</Typography>

                                                <Typography  style={{fontSize:20 , textAlign: 'left', alignSelf: 'left'  , width:'40%'}}>   = {( this.state.tax).toFixed(2)}  </Typography>


                                            </div>
                                            <div  style={{display: 'flex',
                                                flexDirection: 'row',}}>
                                                <Typography  style={{fontSize:20 , textAlign: 'left', alignSelf: 'left'  , width:'55%'}}>Shipping & Handling </Typography>

                                                <Typography  style={{fontSize:20 , textAlign: 'left', alignSelf: 'left'  , width:'40%'}}> =  {(this.state.shippingCost).toFixed(2)}  </Typography>


                                            </div>
                                            <div  style={{display: 'flex',
                                                flexDirection: 'row',}}>
                                                {/*<TextField required id="number" name="potCount"  label="Tax"  fullWidth style = { { textAlign: 'center', alignSelf: 'center'  , backgroundColor:inputBoxColor, fontSize:26, marginLeft:3,  width:'10%'}}  InputLabelProps={{ shrink: this.state.inputFieldShrinkState || this.state.numberShrink  }}  value={this.state.selectedCard.number} onChange={this.handleNumberChange}/>*/}

                                                <Typography  style={{fontSize:20 , textAlign: 'left', alignSelf: 'left'  , width:'55%'}}>Grand Total </Typography>

                                                <Typography  style={{fontSize:20 , textAlign: 'left', alignSelf: 'left'  , width:'40%'}}>  =  {( this.state.grandTotal).toFixed(2)}  </Typography>


                                            </div>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={1} sm={1}  md={12} lg={12}   xl={12}>

                                    </Grid>

                                </Grid>
                            </DialogContent>
                            <DialogActions>
                                {/*
																										<Tooltip title="Selected entities will receive police notice">
																											<Button  color="primary" onClick={this.sendEmail}>Send EMAIL</Button>
																										</Tooltip>
																										*/}
                                <Button onClick={this.handleClickShowCheckoutClose}  style={{backgroundColor :'white',  border: '2px solid', color:'red', borderColor:'red', borderWidth:'2px', marginRight:20 }} className={classes.purchasebutton}>Cancel</Button>
                                <Button onClick={this.handlePurchase}   style={{backgroundColor :'#1a736a',  border: '2px solid', color:'white', borderColor:'black', borderWidth:'2px', marginRight:80 }} className={classes.purchasebutton}>Submit Purchase Request</Button>
                            </DialogActions>
                        </Dialog>
                        {/* Disclaimer Dialog */}
                        <Dialog
                            open={this.state.showDisclaimerDialog}
                            onClose={this.handleClickShowDisclaimerClose}
                            scroll={'paper'}
                            classes={{
                                paper: classes.formControl3,
                            }}
                            style = { { marginLeft:30,   width:'80%' , border: '4px solid',  borderColor:'red', borderWidth:'4px', textAlign: 'center', alignSelf: 'center'}}
                            aria-labelledby="scroll-dialog-title"
                            aria-describedby="scroll-dialog-description"
                            maxWidth="sm"
                        >
                            <DialogTitle id="scroll-dialog-title" style={{marginLeft:20, textAlign: 'center', alignSelf: 'center'}}>Orchima™ Product Disclaimer</DialogTitle>
                            <DialogContent id="checkout" dividers="paper">
                                <Grid container spacing={24}  style={{marginLeft:20, textAlign: 'left', alignSelf: 'left', backgroundColor:'white'}} >
                                    <Grid item xs={2} sm={2}  md={2} lg={2}   xl={2}>

                                    </Grid>
                                    <Grid item xs={8} sm={8}  md={8} lg={8}   xl={8}>
                                        <Grid item xs={12} sm={12}  md={12} lg={12}   xl={12}  style={{ backgroundColor:'white'  }}>
                                            <div  style={{display: 'flex',
                                                flexDirection: 'row' }}>
                                                <Typography  style={{fontSize:16 , textAlign: 'left', alignSelf: 'left'   , marginTop:10, marginLeft:5 ,marginRight:15 , backgroundColor:'white', width:'100%'}}> Disclaimer and Limitation of Liability.
                                                    The Orchima™ pot has been thoughtfully designed for home and decorative use with bark-based orchid planting media. Please read and follow all care and usage instructions provided.</Typography>

                                            </div>

                                        </Grid>
                                        <Grid item xs={12} sm={12}  md={12} lg={12}   xl={12}  style={{ backgroundColor:'white'  }}>
                                            <div  style={{display: 'flex',
                                                flexDirection: 'row' }}>
                                                <Typography  style={{fontSize:16 , textAlign: 'left', alignSelf: 'left'   , marginTop:10, marginLeft:5 ,marginRight:15 , backgroundColor:'white', width:'100%'}}>
                                                    By purchasing or using this product, the user acknowledges and agrees that Orchima™ and its affiliates are not responsible or liable for
                                                    any direct, indirect, incidental, or consequential damages resulting from improper use, misuse, modification,
                                                    or failure to follow the provided instructions.</Typography>
                                            </div>

                                        </Grid>
                                        <Grid item xs={12} sm={12}  md={12} lg={12}   xl={12}  style={{ backgroundColor:'white'  }}>
                                            <div  style={{display: 'flex',
                                                flexDirection: 'row' }}>
                                                <Typography  style={{fontSize:16 , textAlign: 'left', alignSelf: 'left'   , marginTop:10, marginLeft:5 ,marginRight:15 , backgroundColor:'white', width:'100%'}}>
                                                    The user assumes full responsibility for ensuring that use of the product is appropriate for their environment and
                                                    does not cause damage to plants, furnishings, surfaces, or property.
                                                </Typography>
                                            </div>

                                        </Grid>
                                        <Grid item xs={12} sm={12}  md={12} lg={12}   xl={12}  style={{ backgroundColor:'white'  }}>
                                            <div  style={{display: 'flex',
                                                flexDirection: 'row' }}>
                                                <Typography  style={{fontSize:16 , textAlign: 'left', alignSelf: 'left'   , marginTop:10, marginLeft:5 ,marginRight:15 , backgroundColor:'white', width:'100%'}}>

                                                    Orchima™ makes no express or implied warranties beyond those required by applicable law, including but not limited to implied
                                                    warranties of merchantability or fitness for a particular purpose.
                                                    If the product is found defective, liability shall be limited solely to
                                                    the replacement of the product or refund of its purchase price, at the company’s discretion.</Typography>
                                            </div>

                                        </Grid>
                                    </Grid>
                                    <Grid item xs={2} sm={2}  md={2} lg={2}   xl={2}>

                                    </Grid>

                                </Grid>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={this.handleContinuePurchase}   style={{backgroundColor :'#1a736a',  border: '2px solid', color:'white', borderColor:'black', borderWidth:'2px', marginRight:80 }} className={classes.purchasebutton}>Continue Purchase</Button>
                            </DialogActions>
                        </Dialog>
                    </Grid>
                </div>
            </React.Fragment>
        );
    }//end of render



    editRecord(singleRowData){
        this.setState({inputFieldShrinkState:true});
        this.setState({selectedCard:singleRowData });
        //We need to change the seleted Location as well.
        //let tempLocation = this.props.locationsArray.find(x => x.locationId == singleRowData.locationId );

        //this.setState({selectedLocation:tempLocation });

    }


    deleteRecord(argProcessId){
        //alert('I am deleting ' + argCameraId);
        let { deleteACard } = this.props;
        deleteACard(DEFAULT_VESPAAN_SERVER.url,argProcessId  );
    }

    /*handleClickOpen(){
        this.setState({ open: true });
    };

    handleClose(){
        this.setState({ open: false });
    };*/

    componentDidMount() {
        const { isAuthenticated ,updateUserProfileAction} = this.props;
        //isAuthenticated();
        //updateUserProfileAction(this.props.userProfile, this.props.loginData.accessToken);
        //updateUserProfileAction(null, this.props.loginData.accessToken);
        this.getPotPriceFromServer(DEFAULT_VESPAAN_SERVER.url);
        //updateAuth();
        // console.log("Farshid the loginData " + this.props.loginData.accessToken)  ;

    }

    componentWillMount(){
        let { loadCardsData , loadLocationsData } = this.props;
        loadCardsData(DEFAULT_VESPAAN_SERVER.url );
        //loadLocationsData("http://localhost:9065/" );

        this.setState({
            errorCMsg:{}
        });


    }

    componentWillReceiveProps(nextProps) {
        if (this.props.cardsArray !== nextProps.cardsArray) {
            this.setState({
                cardsArray: nextProps.cardsArray
            });
        }
        if (nextProps.errorCMsg.status != null) {
            if (nextProps.errorCMsg.status != null) {
                this.handleClickShowSavedCard();
            }
        }

    }



}//end of class

CreditCard.propTypes = {
    classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
    return {
        cardsArray: state.card.cardsArray,
        CardDeleteResponse:state.card.deleteCardResp,
        CardSaveResponse:state.card.saveCardResp,
        //locationsArray:state.location.locationsArray,
        //vcArray:state.videocontroller.vcArray,
        //camerasArray:state.camera.camerasArray,
        errorCMsg:state.card.errorCMsg,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        loadCardsData:loadCardsData,
        deleteACard:deleteACard,
        saveACard:saveACard,
        updateACard:updateACard,
        clearCardErrorMsg:clearCardErrorMsg,

    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(CreditCard));
